const pt={
	    "home":{
        "name": "home",
        "url":"/",
        "title": "LEVTY",
        "description": "Times especializados para elevar a transformação digital da sua organização. Monte squads de desenvolvimento para acelerar a construção do seu projeto e lançar produtos digitais de alta qualidade."
    },

    "specializedTeams": {
        "title": "Equipes especializadas em transformação digital",
        "description": "Times de profissionais qualificados em plataforma digital corporativa que trabalham de forma dedicada como parte da sua organização."
    },

    "teamAsService":{
        "title": "Team as a service",
        "description": "Fornecemos à sua organização uma ou mais equipes de Engenheiros de Software capacitados em uma plataforma digital para atender aos seus requisitos."
    },

    "management":{
        "title": "Gestão e flexibilidade",
        "description": "Nossos times adotam metodologia especializada, ferramenta online de gestão de projetos ágeis e comunicação por chat, telefone fixo e e-mail.",
        "features":[
            {
                "title":"Produtividade",
                "description":"Nosso time de desenvolvimento utiliza metodologias ágeis, garantindo a eficiência das entregas."
            },
            {
                "title":"Previsibilidade de Custo",
                "description":"Modelos personalizados de acordo com o perfil da sua organização."
            },
            {
                "title":"Equipe Escalável",
                "description":"Monte times multidisciplinares para construir e publicar projetos com qualidade."
            },
            {
                "title":"Profissionais Qualificados",
                "description":"Times com Engenheiros de Software experientes vão trabalhar exclusivamente em seu projeto."
            },
            {
                "title":"Transparência",
                "description":"Acompanhe as entregas, visibilidade de backlog e status através de canal direto de comunicação."
            },
            {
                "title":"Retenção de Talentos",
                "description":"Nossos profissionais são escolhidos com critério e oferecemos diversos diferenciais para que se envolvam totalmente com seu projeto."
            }
        ]
    },

    "teamsModels":{
        "title": "Modelos de times para cada escala de negócio",
        "description": "Nossos modelos de times incluem, além da equipe de desenvolvimento de software, o Diretor da Unidade e o Gerente de Conta.",
        "packs": [
            {
                "title":"Mínimo",
                "description": "2 Engenheiros de Software",
                "scrum": "1 Scrum Master / Product Owner / Líder de Desenvolvimento",
                "dev": "1 Desenvolvedor"
            },
            {
                "title":"Básico",
                "description": "3 Engenheiros de Software",
                "scrum": "1 Scrum Master / Product Owner",
                "devLead": "1 Líder de Desenvolvimento",
                "dev":"1 Desenvolvedor"
            },
            {
                "title":"Completo",
                "description": "5 Engenheiros de Software",
                "scrum": "1 Scrum Master / Product Owner",
                "devLead": "1 Líder de Desenvolvimento",
                "dev":"3 Desenvolvedores"
            }
        ]
    },

    "ourTechnology":{
        "title": "Nossa tecnologia",
        "description": "Somos parceiros oficiais da SYDLE, especializados na plataforma SYDLE ONE, incluindo suas soluções.",
        "bpm":"BPM",
        "ecm":"ECM",
        "crm":"CRM",
        "billing":"Billing",
        "ecommerce":"E-commerce",
        "servicedesk":"Service Desk/ITSM",
        "powerManagement":"Gestão de Energia",
        "analytics":"Analytics",
        "learnMore":"Saiba mais"
    },

    "buildTeam":{
        "title": "Monte uma equipe para sua organização",
        "description": "Conte com nossa flexibilidade para projetar equipes coesas com base nos seus objetivos e necessidades. Entre em contato para mais informações."
    },
    
    "button":{
        "plans":"Planos",
        "career":"Carreiras",
        "contact":"Entre em contato",
        "learnMore":"Saiba mais"
    },

    "customers": {
        "title": "Conheça nossos clientes",
        "description": "Empresas que confiam nos times de especialistas em transformação digital da LEVTY."
    }
} 
export default pt